<template>
  <div
    :id="quaterId"
    class="availability-calendar-quater-main d-flex justify-content-start relative"
    :class="mainClasses"
    :data-day="day.id"
    :data-hour="hour.id"
    @click="onClickHandler"
  >
    <div
      :id="'container-' + quaterId"
      class="d-flex quater-item-container"
      :class="containerClasses"
    >
      <div
        v-for="(item, index) in allData.data"
        :key="`quater-item-${index}`"
        :class="itemClasses(item)"
      >
        <popper
          :ref="`quater-item-${index}`"
          :options="{
            placement: 'right',
            modifiers: { offset: { offset: '0,0px' } },
          }"
          trigger="clickToOpen"
          @show="showPopper"
        >
          <div class="popper">
            <PopperStudentInformation
              :edit-mode="editMode"
              :index="index + 1"
              :is-in-other-company="isInOtherCompany"
              :is-in-other-location="isInOtherLocation"
              :total-mounted="allData.data.length"
              :value="item"
              @changeIndex="onChangeIndex"
              @edit-admission="handleEdit"
              @remove-admission="handleRemove"
            />
          </div>
          <template slot="reference">
            <div
              class="flex-fill quater-item"
              :class="referenceClasses(item, index)"
              style="position: relative;"
            >
              <p :class="isInOtherLocation ? 'mb-4' : 'mb-0'">
                <span v-if="!isInOtherLocation">
                  {{ studentName(item) }}
                </span>
              </p>
            </div>
          </template>
        </popper>
      </div>
    </div>
    <div
      v-if="showAdmissionQuater"
      class="admission-quater w-100 relative"
      :class="admissionQuaterClasses"
    >
      <div class="mx-2">
        <span class="absolute fs-12 ">
          {{ `${admission.fullName} - ${admission.studentSieId}` }}
        </span>
        <span class="absolute fs-16">
          {{ `${admissionSpaceIndex + 1}/${frequencyNumber}` }}
        </span>
      </div>
    </div>
    <div class="py-3 " />
  </div>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
import PopperStudentInformation from './PopperStudentInformation.vue';
import alertMixin from '@/mixins/alert.mixin';
import { modalityTypes } from '@/utils/constants/modalityTypes';
import disciplineTypeCode from '@/utils/constants/disciplineTypeCode';
import Durations from '@/utils/constants/durations.js';
import AdmissionStatus from '@/utils/shared/constants/admissionStatus';
const COMPLETEDFRECUENCYTYPES = Object.freeze({
  ONETIMEPERMONTH: 827,
  TWOTIMESPERMONTH: 846,
  FORTNIGHTLY: 301,
});
const MODALITIES = Object.freeze({
  COMPLEMENTARY: 491,
});
export default {
  name: 'AvailabilityCalendarQuater',
  components: {
    Popper,
    PopperStudentInformation,
  },
  mixins: [alertMixin],
  props: {
    quater: {
      type: Number,
      default: () => 0,
    },
    allData: {
      type: Object,
      default: () => {},
    },
    hour: {
      type: Object,
      default: () => {},
    },
    day: {
      type: Object,
      default: () => {},
    },
    admission: {
      type: Object,
      default: () => null,
    },
    scheduleId: {
      type: Number,
      default: () => 0,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    admissionSpaceSelected: {
      type: Number,
      default: () => 0,
    },
    filter: {
      type: Object,
      default: () => null,
    },
    selectedDay: {
      type: Object,
      default: () => null,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    spaceList: {
      type: Array,
      default: () => [],
    },
    editInfo: {
      type: Object,
      default: () => null,
    },
    isAdmissionCoordination: {
      type: Boolean,
      default: false,
    },
    isCoordination: {
      type: Boolean,
      default: false,
    },
    isTransfer: {
      type: Boolean,
      default: false,
    },
    practitionerId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    studentName() {
      return (item) => {
        return item.studentFirstName.charAt(0) + item.studentLastName.charAt(0);
      };
    },
    isAvailable() {
      return this.allData.type == 1;
    },
    isNotAvailable() {
      return this.allData.type == 2;
    },
    isGroup() {
      return this.allData.data.some(
        (x) => x.modalityId != modalityTypes.IndividualTherapy
      );
    },
    isIndividual() {
      return this.allData.data.some(
        (x) => x.modalityId == modalityTypes.IndividualTherapy
      );
    },
    isStudentWithChangedService() {
      return (item) =>
        item.admissionStatusId == AdmissionStatus.NoVigenteCambioServicio;
    },
    dataEmpty() {
      return this.allData.type == 0;
    },
    addAvailableSpaceIcon() {
      return require('@/assets/img/circle-plus.svg');
    },
    quaterId() {
      return `${this.day.id}-${this.hour.id}-${this.quater}`;
    },
    frequencyNumber() {
      if (!this.admission) return null;
      if (this.editMode) return 1;
      if (
        this.admission.frequencyTypeId == COMPLETEDFRECUENCYTYPES.FORTNIGHTLY
      ) {
        return 2;
      }
      return Number(this.admission.frequency.match(/\d/g)?.join(''));
    },
    duration() {
      if (!this.admission) return null;
      return Number(this.admission.duration.match(/\d/g).join(''));
    },
    showAdmissionQuater() {
      if (!this.admission) return false;
      return this.admission.spaces.some(
        (x) => this.allData.scheduleId === x.scheduleId
      );
    },
    admissionSpaceIndex() {
      return this.admission.spaces.findIndex(
        (x) => this.allData.scheduleId === x.scheduleId
      );
    },
    isInOtherLocation() {
      if (!this.filter || !this.allData.data.length) return false;
      return this.allData.data.some(
        (x) =>
          (x.locationId != 0 &&
            this.filter.locationService?.id != x.locationId) ||
          (x.disciplineTypeId != 0 &&
            this.filter.disciplineType?.id != x.disciplineTypeId)
      );
    },
    isInOtherCompany() {
      if (!this.filter || !this.allData.data.length) return false;
      return this.allData.data.some(
        (x) => x.companyId != 0 && this.filter.provider.id != x.companyId
      );
    },
    id() {
      const { id } = this.editInfo || {};
      return id ? Number(id) : null;
    },
    mainClasses() {
      return [
        { 'available-empty': this.dataEmpty },
        { 'not-available': !this.isAvailable },
        { available: this.isAvailable },
        { 'bg-gray-custom ': !this.isAvailable && !this.isNotAvailable },
        { 'w-100': this.selectedDay },
      ];
    },
    containerClasses() {
      return [{ individual: this.isIndividual }];
    },
    admissionQuaterClasses() {
      return [
        { 'padding-15': this.duration === 15 },
        { 'padding-30': this.duration === 30 },
        { 'padding-45': this.duration === 45 },
        { 'padding-60': this.duration === 60 },
      ];
    },
  },
  methods: {
    handleEdit(e) {
      const emitData = { ...e, scheduleId: this.allData.scheduleId };
      this.$emit('edit-admission', emitData);
      if (e?.index != null) this.closePopperByIndex(e.index - 1);
    },

    handleRemove(e) {
      const emitData = { ...e, scheduleId: this.allData.scheduleId };
      this.$emit('remove-admission', emitData);
      if (e?.index != null) this.closePopperByIndex(e.index - 1);
    },
    closePopperByIndex(index) {
      const ref = this.$refs[`quater-item-${index}`];
      const inst = Array.isArray(ref) ? ref[0] : ref;
      inst && (inst.showPopper = false);
    },
    async onChangeIndex({ nextIndex, previousIndex }) {
      const previousElement = this.$refs['quater-item-' + (previousIndex - 1)];
      previousElement[0].showPopper = false;
      const nextElement = this.$refs['quater-item-' + (nextIndex - 1)];
      await this.delay(100);
      await nextElement[0].createPopper();
      nextElement[0].doShow();
    },
    delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    onClickHandler($event) {
      const targetElement = $event.target;
      if (
        (this.isAdmissionCoordination ||
          this.isCoordination ||
          this.isTransfer ||
          this.editMode) &&
        this.admission &&
        !this.dataEmpty
      ) {
        this.manageAdmissionSelection(targetElement);
        return;
      }
      const allItems = document.querySelectorAll(
        '.availability-calendar-quater-main.available-empty'
      );
      [...allItems].forEach((element) => element.classList.remove('active'));
      targetElement.classList.add('active');
      this.$emit('add-available-space', {
        data: {
          day: { ...this.day },
          hour: { ...this.hour },
          quater: this.quater,
          type: this.type,
        },
        element: targetElement,
      });
    },
    manageAdmissionSelection(targetElement) {
      if (this.admissionSelected) return;
      if (!this.isAvailable) return;
      if (this.admission.spaces.length === this.frequencyNumber) return;
      if (
        this.admission.spaces.some(
          (x) => x.scheduleId === this.allData.scheduleId
        )
      )
        return;
      if (
        this.allData.data.some(
          (x) => x.modalityId != this.admission.modalityId
        ) &&
        this.admission.modalityId !== MODALITIES.COMPLEMENTARY
      ) {
        this.ShowToast(
          'Error',
          'Todos los servicios deben estar en la misma modalidad.',
          'error'
        );
        return;
      }
      if (
        this.allData.data.some(
          (x) => x.disciplineTypeId != this.admission.disciplineTypeId
        )
      ) {
        this.ShowToast(
          'Error',
          'Todos los servicios deben estar en la misma disciplina.',
          'error'
        );
        return;
      }
      if (
        this.allData.data.some(
          (x) =>
            x.durationId != this.admission.durationId &&
            (x.practitionerId == this.practitionerId ||
              (x.practitionerId === null && this.practitionerId === 0))
        )
      ) {
        this.ShowToast(
          'Error',
          'Los servicios tienen que ser de la misma duración para poder ser coordinados en el mismo espacio.',
          'error'
        );
        return;
      }
      const isGroup = this.admission?.modalityId === modalityTypes.GroupTherapy;
      const isValidDuration = this.admission?.durationId === Durations.MIN30;
      if (isGroup && isValidDuration && this.allData.data.length >= 2) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio ya que no se pueden asignar más de dos (2) estudiantes a una sesión grupal de 30 minutos.',
          'error'
        );
        return;
      }

      const ocupacionalServices = this.allData.data.filter(
        (item) =>
          item.disciplineTypeId === disciplineTypeCode.TerapiaOcupacional &&
          (item.practitionerId == this.practitionerId ||
            (item.practitionerId === null && this.practitionerId === 0))
      );
      const otherServices = this.allData.data.filter(
        (item) =>
          item.disciplineTypeId !== disciplineTypeCode.TerapiaOcupacional &&
          (item.practitionerId == this.practitionerId ||
            (item.practitionerId === null && this.practitionerId === 0))
      );
      const ocupacionalOccurrences = ocupacionalServices.reduce((acc, item) => {
        const key = `${item.disciplineTypeId}-${item.practitionerId ?? 0}`;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});

      const otherOccurrences = otherServices.reduce((acc, item) => {
        const key = `${item.disciplineTypeId}-${item.practitionerId ?? 0}`;
        acc[key] = (acc[key] || 0) + 1;
        return acc;
      }, {});

      const hasReachedMaxServices =
        Object.values(ocupacionalOccurrences).some((count) => count === 5) ||
        Object.values(otherOccurrences).some((count) => count === 4);

      if (hasReachedMaxServices) {
        this.ShowToast(
          'Error',
          'No es posible coordinar el servicio ya que el grupo cuenta con el máximo de estudiantes.',
          'error'
        );
        return;
      }
      const quaterElements = [targetElement];
      const quaterParts = this.duration / 5;
      for (let index = 1; index < quaterParts; index++) {
        const previous = quaterElements[index - 1];
        const next = this.findNextQuaterSibling(previous, index);
        if (next === null) {
          this.ShowToast(
            'Error',
            'El espacio seleccionado esta fuera de los espacios de disponibilidad.',
            'error'
          );
          return;
        }
        quaterElements.push(next);
      }

      if (!this.editMode) {
        const sameDay = this.admission.spaces.some(
          (x) => x.day.id === this.day.id
        );
        const sameStudent = this.allData.data.some(
          (x) => x.studentSieId === this.admission.studentSieId
        );
        if (sameDay || sameStudent) {
          this.ShowToast(
            'Error',
            'No se permite coordinar mas de un espacio el mismo dia para el servicio del estudiante.',
            'error'
          );
          return;
        }

        const someIsNotAvailable = quaterElements.some((q) =>
          ['available-empty', 'not-available'].some(
            (c) =>
              q?.classList?.contains(c) ||
              [...q?.children]?.some(
                (h) =>
                  h?.classList.contains(c) ||
                  [...h?.children]?.some((g) => g?.classList?.contains(c))
              )
          )
        );

        if (someIsNotAvailable) {
          this.ShowToast(
            'Error',
            'Todos los espacios deben estar disponibles para agregar esta disponibilidad.',
            'error'
          );
          return;
        }
      } else {
        let quatersToAffected = [];
        for (let index = 0; index < quaterParts; index++) {
          let quaterNumber = this.quater + index * 5;
          let hour = this.hour.id;
          let day = this.day.id;
          if (quaterNumber > 55) {
            quaterNumber = quaterNumber - 60;
            hour = hour + 1;
          }
          if (hour > 19) {
            hour = 7;
            day = day + 1;
          }
          const quater = document.getElementById(
            `${day}-${hour}-${quaterNumber}`
          );
          quatersToAffected.push(quater);
        }

        const day = quatersToAffected[0]?.__vue__?.day.id;

        const someIsNotAvailable = quatersToAffected.some((q) =>
          ['available-empty', 'not-available'].some(
            (c) =>
              q?.classList?.contains(c) ||
              [...q?.children]?.some(
                (h) =>
                  h?.classList.contains(c) ||
                  [...h?.children]?.some((g) => g?.classList?.contains(c))
              )
          )
        );

        if (someIsNotAvailable) {
          this.ShowToast(
            'Error',
            'Todos los espacios deben estar disponibles para agregar esta disponibilidad.',
            'error'
          );
          return;
        }

        const sameStudent = this.spaceList
          .filter((x) => x.dayOfWeek == day && x.admissions.length > 0)
          .map((x) => x.admissions)
          .flat()
          .some(
            (x) =>
              x.studentSieId === this.admission.studentSieId && x.id !== this.id
          );
        if (sameStudent) {
          this.ShowToast(
            'Error',
            'No se permite coordinar mas de un espacio el mismo dia para el servicio del estudiante.',
            'error'
          );
          return;
        }
      }

      const startAmPM = targetElement.parentElement.parentElement.parentElement.firstChild.textContent
        .trim()
        .split(' ')[1];
      const endElement = quaterElements[quaterElements.length - 1];

      const endAmPm = endElement?.parentElement?.parentElement?.parentElement?.firstChild?.textContent
        ?.trim()
        ?.split(' ')[1];
      this.$emit('add-admission-available-space', {
        day: { ...this.day },
        hour: { ...this.hour },
        quater: this.quater,
        scheduleId: this.allData.scheduleId,
        type: this.allData.type,
        duration: this.duration,
        ampm: { start: startAmPM, end: endAmPm },
        data: this.allData.data,
      });
    },
    findNextQuaterSibling(el, index) {
      let { parentElement, nextSibling } =
        index === 1 ? el.parentElement.parentElement : el;
      if (this.hour.id < 20 || (this.hour.id === 20 && this.quater < 55)) {
        if (!nextSibling) {
          const nextRow = parentElement.parentElement.parentElement.nextSibling;
          if (!nextRow) return null;
          const columns = nextRow.firstChild.nextElementSibling.children;
          nextSibling = columns[this.day.id - 1]?.firstChild;
        }
      }
      return nextSibling;
    },
    showPopper(state) {
      this.$emit('show-popper-state', state._data);
    },
    itemClasses(item) {
      return [
        { 'flex-fill': this.isIndividual && !item.hasPractitioner },
        { 'container-group': this.isGroup || item.hasPractitioner },
      ];
    },
    referenceClasses(item, index) {
      return [
        { 'type-individual': this.isIndividual },
        {
          'type-individual-editMode':
            this.isIndividual &&
            (this.editMode || this.isStudentWithChangedService(item)) &&
            this.id == item.id,
        },
        {
          'type-individual-student-changed-service':
            this.isIndividual && this.isStudentWithChangedService(item),
        },
        {
          'dashed-individual':
            this.isInOtherLocation &&
            !this.isInOtherCompany &&
            this.isIndividual,
        },
        {
          'dashed-gray-individual': this.isInOtherCompany && this.isIndividual,
        },
        { 'type-group': this.isGroup },
        {
          'type-group-editMode':
            this.isGroup && this.editMode && this.id == item.id,
        },
        {
          'type-group-student-changed-service':
            this.isGroup && this.isStudentWithChangedService(item),
        },
        {
          'dashed-group-y':
            this.isInOtherLocation && !this.isInOtherCompany && this.isGroup,
        },
        {
          'dashed-gray-group-y': this.isInOtherCompany && this.isGroup,
        },
        {
          'dashed-group-l border-right-0 mr-0':
            this.isInOtherLocation &&
            !this.isInOtherCompany &&
            this.isGroup &&
            index === 0,
        },
        {
          'dashed-gray-group-l border-right-0 mr-0':
            this.isInOtherCompany && this.isGroup && index === 0,
        },
        {
          'border-right-0 border-left-0 mx-0':
            (this.isInOtherLocation || this.isInOtherCompany) &&
            this.isGroup &&
            index !== 0 &&
            index !== this.allData.data.length - 1,
        },
        {
          'dashed-group-r border-left-0 ml-0':
            this.isInOtherLocation &&
            !this.isInOtherCompany &&
            this.isGroup &&
            index === this.allData.data.length - 1,
        },
        {
          'dashed-gray-group-r border-left-0 ml-0':
            this.isInOtherCompany &&
            this.isGroup &&
            index === this.allData.data.length - 1,
        },
        { 'not-available': this.isNotAvailable },
        { practitioner: item.hasPractitioner },
        { available: this.isAvailable },
        { 'padding-15': item.durationMinutes == 15 },
        { 'padding-30': item.durationMinutes == 30 },
        { 'padding-45': item.durationMinutes == 45 },
        { 'padding-60': item.durationMinutes == 60 },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
@import '@/scss/availability_calendar_colors.scss';
.availability-calendar-quater-main {
  cursor: pointer;
  min-width: 100px;
  box-sizing: content-box;
  margin: 0;
  padding: 0;
  border-bottom: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
}

.quater-item {
  text-align: center;
  margin: 0 1px 0 1px;
  font-size: 10px;
  font-weight: bold;
  line-height: 22px;
}
.quater-item-container {
  width: 100%;
}

.quater-item-container.individual {
  width: 100%;
}

.container-group {
  width: 20%;
  max-width: 35.5px;
}

.quater-item.type-individual {
  background-color: $student-individual-modality-background;
  border-left: 4px solid $student-individual-modality-accent;
  width: 100%;
  position: absolute;
}

.quater-item.type-group {
  background-color: $student-group-modality-background;
  border-left: 4px solid $student-group-modality-accent;
}

.quater-item.practitioner {
  background-color: $student-practitioner-background !important;
  border-left: 4px solid $student-practitioner-accent !important;
}

.not-available {
  background-color: #e8e8e8;
}

.padding-15 {
  padding: 39px 0;
}

.padding-30 {
  padding: 90px 0;
}

.padding-45 {
  padding: 141px 0;
}

.padding-60 {
  padding: 192px 0;
}
.availability-calendar-quater-main {
  height: 33px !important;
}
.admission-quater.padding-15 {
  padding: 50px 0;
}
.admission-quater.padding-30 {
  padding: 101px 0;
}
.admission-quater.padding-45 {
  padding: 152px 0;
}
.admission-quater.padding-60 {
  padding: 203px 0;
}
.availability-calendar-quater-main.available-empty.active {
  background-color: map-get($colors, 'orange') !important;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi43ODYiIGhlaWdodD0iMTYuNzg2IiB2aWV3Qm94PSIwIDAgMTYuNzg2IDE2Ljc4NiI+CiAgPHBhdGggaWQ9ImNpcmNsZS1wbHVzIiBkPSJNMCw4LjM5M2E4LjM5Myw4LjM5MywwLDEsMSw4LjM5Myw4LjM5M0E4LjM5Miw4LjM5MiwwLDAsMSwwLDguMzkzWm04LjM5MywzLjY3MmEuNzg1Ljc4NSwwLDAsMCwuNzg3LS43ODdWOS4xOGgyLjFhLjc4Ny43ODcsMCwxLDAsMC0xLjU3NEg5LjE4di0yLjFhLjc4Ny43ODcsMCwxLDAtMS41NzQsMHYyLjFoLTIuMWEuNzg3Ljc4NywwLDAsMCwwLDEuNTc0aDIuMXYyLjFBLjc4NS43ODUsMCwwLDAsOC4zOTMsMTIuMDY1WiIgZmlsbD0iI2Y3ZjdmNyIvPgo8L3N2Zz4K');
}
.availability-calendar-quater-main .admission-quater {
  background-color: map-get($colors, 'orange') !important;
  color: white !important;
  z-index: 9;
  position: absolute;
}
.availability-calendar-quater-main .admission-quater span:first-child {
  top: 0;
}
.availability-calendar-quater-main .admission-quater span:last-child {
  bottom: 0;
}
.fs-16 {
  font-size: 16px;
}
.fs-12 {
  font-size: 12px;
}
.popper {
  background-color: #fff;
  box-shadow: 0px 2px 8px #0000001c;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
@media (max-width: 768px) {
  .popper {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    top: auto !important;
    z-index: 999999999;
    width: 100vw !important;
    transform: unset !important;
  }

  .availability-calendar-quater-main {
    width: 101px;
    box-sizing: border-box;
  }

  .container-group {
    width: 20.5px;
  }
}

.quater-item {
  text-align: center;
  margin: 0 1px 0 1px;
  font-size: 10px;
  font-weight: bold;
  line-height: 22px;
  position: relative;
  z-index: 1;
}
.quater-item.type-individual {
  background-color: $student-individual-modality-background;
  border-left: 4px solid $student-individual-modality-accent;
  width: 100%;
  position: absolute;
}

.quater-item.type-group {
  background-color: $student-group-modality-background;
  border-left: 4px solid $student-group-modality-accent;
}
.dashed-group-y {
  border-top: 4px dashed $student-group-modality-accent;
  border-bottom: 4px dashed $student-group-modality-accent;
  background-color: $student-group-modality-background !important;
}
.dashed-group-r {
  border-right: 4px dashed $student-group-modality-accent !important;
  background-color: $student-group-modality-background !important;
}
.dashed-group-l {
  border-left: 4px dashed $student-group-modality-accent !important;
  background-color: $student-group-modality-background !important;
}
.dashed-individual {
  border: 4px dashed $student-individual-modality-accent !important;
  background-color: $student-individual-modality-background !important;
}
.dashed-gray-individual {
  border: 4px dashed $hour-out-corporation-accent !important;
  background-color: $hour-out-corporation-background !important;
}

.dashed-gray-group-y {
  border-top: 4px dashed $hour-out-corporation-accent !important;
  border-bottom: 4px dashed $hour-out-corporation-accent !important;
  background-color: $hour-out-corporation-background !important;
}

.dashed-gray-group-r {
  border-right: 4px dashed $hour-out-corporation-accent !important;
  background-color: $hour-out-corporation-background !important;
}
.dashed-gray-group-l {
  border-left: 4px dashed $hour-out-corporation-accent !important;
  background-color: $hour-out-corporation-background !important;
}

.quater-item.type-individual-editMode {
  background-color: #fce0c7;
  border-left: 4px solid #ff7059;
  width: 100%;
  position: absolute;
}

.quater-item.type-group-editMode {
  background-color: #fce0c7;
  border-left: 4px solid #ff7059;
}
.quater-item.type-group-student-changed-service {
  background-color: $student-change-service-background;
  border-left: 4px solid $student-change-service-accent;
}

.quater-item.type-individual-student-changed-service {
  background-color: $student-change-service-background;
  border-left: 4px solid $student-change-service-accent;
  width: 100%;
  position: absolute;
}
.bg-gray-custom {
  background-color: $calendar-accent !important;
  border-color: #c2c2c2;
}
</style>
